import { render, staticRenderFns } from "./GlobalModifierGroupTable.vue?vue&type=template&id=347c0aa0"
import script from "./GlobalModifierGroupTable.vue?vue&type=script&lang=ts"
export * from "./GlobalModifierGroupTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports